import CityPageTemplate from "../city-template/CityPageTemplate";
import { parmaConfig } from "./data";

export default function ParmaPage() {
  return <CityPageTemplate config={parmaConfig} />;
}